export default __webpack_public_path__ + "static/media/CM.f70d872a.svg";